import { Box, Grid, Paper, Typography, useTheme } from "@mui/material";
import { useSpring, animated } from "@react-spring/web";
import { OverridableComponent } from "@mui/material/OverridableComponent";
import { SvgIconTypeMap } from "@mui/material/SvgIcon";

type SmallTextAndIconProps = {
  height: number;
  title: string;
  content: number;
  titleSecondary: string;
  contentSecondary: number;
  backgroundColor: string;
  iconColor: string;
  icon: OverridableComponent<SvgIconTypeMap<{}, "svg">>;
};

const AnimatedNumber = (n: number) => {
  const { number } = useSpring({
    from: { number: 0 },
    number: n,
    delay: 100,
    config: { mass: 1, tension: 20, friction: 10 },
  });
  return <animated.div>{number.to((n) => n.toFixed(0))}</animated.div>;
};

export default function SmallTextAndIcon({
  height,
  title,
  content,
  titleSecondary,
  contentSecondary,
  backgroundColor,
  iconColor,
  icon: Icon,
}: SmallTextAndIconProps) {
  const theme = useTheme();
  return (
    <Paper
      sx={{
        borderRadius: "5px",
        height: height,
        backgroundColor: "transparent",
        boxShadow: "none",
        padding: 2,
        alignContent: "center",
      }}
    >
      <Grid
        container
        flexDirection={"row"}
        justifyContent={"center"}
        alignContent={"center"}
        spacing={5}
      >
        <Grid item display="flex" justifyContent="center" alignItems="center">
          <Box
            sx={{
              backgroundColor: iconColor,
              borderRadius: 5,
              boxShadow: "0px 18px 40px rgba(0, 0, 0, 0.2)",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Icon
              sx={{
                fontSize: "8rem",
                color: "white",
              }}
            />
          </Box>
        </Grid>
        <Grid item>
          <Grid container flexDirection={"column"}>
            <Grid item xs>
              <Grid container flexDirection={"row"} alignItems={"baseline"}>
                <Grid item>
                  <Typography
                    variant="body1"
                    sx={{
                      fontWeight: "normal",
                      color: theme.palette.text.secondary,
                    }}
                  >
                    {title}
                  </Typography>
                </Grid>
                <Grid item sx={{ width: "8px" }} /> {/* Spacer */}
                <Grid item textAlign={"end"}>
                  <Typography variant="h4" color={theme.palette.text.primary}>
                    {AnimatedNumber(content)}
                  </Typography>
                </Grid>
              </Grid>
            </Grid>

            <Grid item xs>
              <Grid container flexDirection={"row"} alignItems={"baseline"}>
                <Grid item>
                  <Typography
                    variant="body1"
                    sx={{
                      fontWeight: "normal",
                      color: theme.palette.text.secondary,
                    }}
                  >
                    {titleSecondary}
                  </Typography>
                </Grid>
                <Grid item sx={{ width: "8px" }} /> {/* Spacer */}
                <Grid item textAlign={"end"}>
                  <Typography variant="h4" color={theme.palette.text.primary}>
                    {AnimatedNumber(contentSecondary)}
                  </Typography>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Paper>
  );
}
